import { render, staticRenderFns } from "./LoginModal.vue?vue&type=template&id=2a058c29&scoped=true&"
import script from "./LoginModal.js?vue&type=script&lang=js&"
export * from "./LoginModal.js?vue&type=script&lang=js&"
import style0 from "./LoginModal.scss?vue&type=style&index=0&id=2a058c29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a058c29",
  null
  
)

export default component.exports